export default "__VITE_ASSET__D69p44qf__"